import React from 'react'

function TotalEligbleIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63056 11.3889L2.23611 6.99444L3.325 5.90556L6.63056 9.21111L13.7667 2.075L14.875 3.14444L6.63056 11.3889ZM1.55556 14.5C1.12778 14.5 0.761444 14.3478 0.456555 14.0434C0.152185 13.7386 0 13.3722 0 12.9444V2.05556C0 1.62778 0.152185 1.26144 0.456555 0.956555C0.761444 0.652185 1.12778 0.5 1.55556 0.5H12.4444C12.5481 0.5 12.6454 0.509593 12.7361 0.528778C12.8269 0.548481 12.9176 0.577778 13.0083 0.616667L11.5694 2.05556H1.55556V12.9444H12.4444V7.77222L14 6.21667V12.9444C14 13.3722 13.8478 13.7386 13.5434 14.0434C13.2386 14.3478 12.8722 14.5 12.4444 14.5H1.55556Z"
        fill="#434343"
      />
    </svg>
  )
}

export default TotalEligbleIcon
